import type { StylePropertiesTypes } from '@wix/document-services-types'
import { getKeywordString } from '../../utils/converterHelpers'

/** Internal Converters */
const overflowConverter = (prop: StylePropertiesTypes.Overflow): string => {
	const x = getKeywordString(prop.x)
	const y = getKeywordString(prop.y)

	// If both x and y are the same, return single value
	// Otherwise return both values (x first, then y)
	if (x === y) {
		return x
	}

	return `${x} ${y}`
}

/** External Map - Only provide converters for new functionality */
export const overflowConverterMap = {
	// Only provide Overflow converter for the composition type
	// KeywordOverflow is already handled by existing Keyword converter
	Overflow: overflowConverter,
} as Record<string, (prop: StylePropertiesTypes.Overflow) => string>
